import React, { useEffect } from "react";
import PaymentCardList from "../../../components/PaymentCardList/PaymentCardList";
import { useCardList } from "../../../services/card-list/card-list.service";
import { CentralLoadingIndicator } from "../../../components";
import { useModal } from "../../../context/ModalContext";
import { MODALS } from "../../../config/params";
import { useCardDetailStore } from "../../../services/card-detail/card-detail.service";
import NullStateMessage from "../../../components/NullStateMessage/NullStateMessage";
import { Button } from "@mui/material";
import AddPaymentIcon from "../../../components/Icons/AddPaymentIcon";
import { userActivityLogger } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";


const GvPaymentMethodContainer = () => {
  const { cardList, loading, getListCards } = useCardList();
  const { openModal } = useModal();
  const { setCardSelected, isCardUpdateInitiated, setCardUpdateStatus } = useCardDetailStore();


  const handleAddPayment = () => {
    userActivityLogger(MIXPANEL_EVENTS.ADD_CARD, {});
    openModal(MODALS.ADD_PAYMENT_METHOD);
  };

  useEffect(() => {
    userActivityLogger(MIXPANEL_EVENTS.VISIT_PAYMENT, {});
    setCardSelected(null);
  }, []);

  useEffect(()=>{
    getListCards();
  }, []);

  useEffect(()=>{
    getListCards();
    isCardUpdateInitiated && setCardUpdateStatus(false);
  }, [isCardUpdateInitiated]);


  if (loading) {
    return <CentralLoadingIndicator message="Hold tight . . . we’re pulling up your payment information." />;
  }


  return (
    <div className="h-full flex justify-center">
      <div className="w-full max-w-[528px] flex flex-col gap-4">
        {cardList && cardList.cards.length > 0 ? (
          <>
            <PaymentCardList cardDetailsList={cardList.cards} />
            <Button
              size="small"
              type="button"
              variant="outlined"
              className="!text-sm !normal-case flex gap-1 items-center"
              onClick={handleAddPayment}>
              <AddPaymentIcon width={17} height={17} />
              Add Payment Method
            </Button>
          </>
        ) : (
          <div className="h-full flex items-center justify-center">
            <div className="w-full max-w-[528px] flex flex-col items-center gap-3 justify-center">
              <NullStateMessage
                imageSrc="/assets/icons/paymentNullState.png"
                message="Set Your Preferred Payment Method"
                subMessage="There are no cards linked to your account. Add one now for hassle-free payments."
              />
              <Button
                size="small"
                type="button"
                variant="outlined"
                className="!text-sm !normal-case flex gap-1 items-center"
                onClick={handleAddPayment}>
                <AddPaymentIcon width={17} height={17} />
                Add Payment Method
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GvPaymentMethodContainer;
